import { Data, DataFromJSON } from '@/api'
import * as runtime from '../runtime'

/**
 * no description
 */
export class DataApi extends runtime.BaseAPI {
  async getData(): Promise<Data> {
    const response = await this.requestGet('/data')
    return new runtime.JSONApiResponse(response, jsonValue =>
      DataFromJSON(jsonValue)
    ).value()
  }
}
